<template>
  <div id="app">
    <a-config-provider :locale="local">
      <component :is="layout" v-if="layout" />
      <keep-alive v-else :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </a-config-provider>
  </div>
</template>

<script>
// 组件
import HomeLayout from '@/layout/HomeLayout'
import DefaultLayout from '@/layout/DefaultLayout'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
// 工具函数
import { mapGetters, mapState } from 'vuex'

export default {
  components: { HomeLayout, DefaultLayout },

  data() {
    return {
      local: zhCN
    }
  },

  computed: {
    ...mapState('system', ['platformConfig']),
    ...mapGetters('system', ['platformTitle']),

    layout() {
      return this.$route.meta.layout
    },

    cachedViews() {
      return this.$store.state.cacheView.cachedViews
    },

    key() {
      return this.$route.path
    }
  },

  watch: {
    // 设置平台名称
    platformTitle(val) {
      document && (document.title = val)
      this.changeFavicon()
    }
  },

  methods: {
    /**
     * 修改平台的ico
     */
    changeFavicon() {
      let $favicon = document.querySelector('link[rel="icon"]')
      if (!this.platformConfig.favicon) {
        const $parent = $favicon.parentElement
        $parent.removeChild($favicon)
      }
      if ($favicon !== null) {
        $favicon.href = this.platformConfig.favicon
      } else {
        $favicon = document.createElement('link')
        $favicon.rel = 'icon'
        $favicon.href = this.platformConfig.favicon
        document.head.appendChild($favicon)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  min-width: $body-width;
}
</style>
